module.exports = __webpack_public_path__ + "img/new_change(2).c4ac6eaa.jpg";